import React, { FC } from "react";
import Image from "apps/website/components/base/Image/Image";
import Button from "apps/website/components/base/Button/Button";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import { WithChildren } from "apps/website/types";
import Icon from "apps/website/components/base/Icon/Icon";

type TImageKey = "cluck" | "gobble" | "mooo" | "quack" | "baaa" | "oink" | "splash" | "swish";

interface IRecipeContentProps {
  imageKey: TImageKey;
}

const IMAGE_KEY_TO_INGREDIENTS: Record<TImageKey, string> = {
  cluck: "chicken",
  gobble: "turkey + chicken",
  mooo: "beef",
  quack: "duck + chicken",
  baaa: "lamb",
  oink: "pork",
  splash: "fish + turkey",
  swish: "fish + chicken",
};

const RecipeContentListItem: FC<WithChildren> = ({ children }) => (
  <li className="flex items-center">

    <div className="text-green">
      <Icon icon="tickHeavy" color="inherit" />
    </div>

    <TextBody>{ children }</TextBody>
  </li>
);

export const RecipeContentVariant: React.FC<IRecipeContentProps> = ({ imageKey }) => (
  <div className="flex flex-col xl:flex-row items-center justify-center gap-4 xl:gap-8 px-2 pt-6 xl:pt-10">
    <div className="w-full xl:w-1/2 flex justify-center xl:justify-end">
      <div className="max-w-[385px] xl:pr-14">
        <Image
          image={{
            src: `/images/landingPage/sectionRecipeComparison/${imageKey.toLowerCase()}.webp`,
            width: 744,
            height: 720,
          }}
          alt={`Image of ${imageKey}`}
          data-testid="RecipeContentVariant-image"
        />
      </div>
    </div>
    <div className="w-full flex flex-col xl:w-1/2 justify-center items-center xl:items-start">
      <div className="max-w-[385px] space-y-8">
        <ul className="space-y-2 xl:space-y-6" data-testid="RecipeContentVariant-list">
          <RecipeContentListItem>Made with fresh, human-quality <TextBody tag="span" weight="bold">{ IMAGE_KEY_TO_INGREDIENTS[imageKey] }</TextBody></RecipeContentListItem>
          <RecipeContentListItem>
            Our special nutrient blend ensures each recipe is complete + balanced
          </RecipeContentListItem>
          <RecipeContentListItem>Gently steamed to lock in moisture, flavour and goodness</RecipeContentListItem>
        </ul>
        <Button to="/sign-up/fresh" size="full-width" data-testid="RecipeContentVariant-cta">Build my box</Button>
      </div>
    </div>
  </div>
);
